import { FC } from 'react'
import tw from 'tailwind-styled-components'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { EmployeeFragment } from '@foros-fe/graphql'
import Placeholder from '@foros-fe/assets/images/about-img-placeholder.png'

type Props = EmployeeFragment & {
  onClick(id: string): void
}

const Container = tw.div<{ $hover: boolean }>`
  flex
  flex-col
  flex-1
  w-[300px]
  lg:w-[240px]
  xl:w-[296px]
  mx-auto
  ${({ $hover }) => ($hover ? 'hover:cursor-pointer' : '')}
`
const ImgContainer = tw.div`
  relative
  flex
  mb-3
  rounded-lg
  overflow-hidden
  h-[260px]
`
const Overlay = tw.div<{ $hover: boolean }>`
  absolute
  w-full
  h-full
  z-20
  bg-transparent
  transition
  duration-300
  ${({ $hover }) => ($hover ? 'hover:bg-gray-500/25' : '')}
`
const Name = tw.p`text-lg font-medium mb-1`

export const AboutUsCard: FC<Props> = ({
  id,
  photoUrl,
  firstName,
  lastName,
  title,
  description,
  onClick,
}) => {
  const { t } = useTranslation('enum')

  return (
    <Container onClick={description ? () => onClick(id) : undefined} $hover={!!description}>
      <ImgContainer>
        <Overlay $hover={!!description} />
        <Image
          src={photoUrl || Placeholder}
          objectFit='cover'
          layout='fill'
          unoptimized={!!photoUrl}
        />
      </ImgContainer>
      <Name>
        {firstName} {lastName}
      </Name>
      <p>{t(`RepresentativeTitle.${title}`)}</p>
    </Container>
  )
}
